import { NEW_ADMIN_MULTIPLOS_ENVIOS } from 'App/featuresFlags';
import useGetTags from '../useGetTags';

function useHasOrdersMultiCD(): boolean {
  const tags = useGetTags();
  return tags.includes(NEW_ADMIN_MULTIPLOS_ENVIOS);
}

export default useHasOrdersMultiCD;
